import { useCallback, useState } from 'react';
import SysAdminTenantFormComponent from '../components/sysadmin-tenant-form.component';
import { TenantCreate, TenantUpdate } from '../types/tenant.types';
import { useTenantCreate } from '../hooks/use-tenant.hook';
import { message } from 'antd';
import { useNavigate } from 'react-router-dom';
import {
  extractCreateError,
  extractValidationError,
} from '../../../../../services/extract-api-error.service';
import HeaderRow from '../../../../common/HeaderRow';
import { ValidationError } from '../../../../../types/api-response.types';
import { useTranslation } from 'react-i18next';
import { WithSysAdminPermissionCheck } from '../../../../auth/WithSysAdminPermissionCheck';
import PageTitle from '@components/common/PageTitle';

const SysAdminTenantCreateContainer = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [validationErrors, setValidationErrors] = useState<ValidationError[]>([]);

  const { mutateAsync: createTenant, isPending } = useTenantCreate();

  const onFormSubmit = useCallback(
    async (data: TenantCreate | TenantUpdate, resetForm: () => void) => {
      // Reset validation errors on new submission
      setValidationErrors([]);

      // For create operations, we know we'll have all required fields
      const createData = data as TenantCreate;
      try {
        const response = await createTenant(createData);
        message.success(t('crud.create.success', { entity: t('tenants.title') }));
        resetForm();
        navigate(`/dashboard/admin/tenant/${response.data.id}/update`);
      } catch (error: any) {
        const errorFields = extractValidationError(error);
        setValidationErrors(errorFields);
        const errorMessage = extractCreateError(
          error,
          t('crud.create.error', { entity: t('tenants.title') })
        );
        message.error(errorMessage);
      }
    },
    [createTenant, navigate, t]
  );

  return (
    <>
      <PageTitle title={t('crud.create.title', { entity: t('tenants.title') })} />
      <HeaderRow
        title={t('crud.create.title', { entity: t('tenants.title') })}
        showBackButton={true}
        isSysAdmin={true}
      />
      <div className="row mt-3">
        <SysAdminTenantFormComponent
          onFormSubmit={onFormSubmit}
          isLoading={isPending}
          columns={3}
          validationErrors={validationErrors}
        />
      </div>
    </>
  );
};

export default WithSysAdminPermissionCheck(SysAdminTenantCreateContainer, 'tenant.create');
